import { Component } from 'react';
import { toast } from 'react-toastify';
import LoadingProgress from '@/components/common/LoadingProgress';
import { AssetPageType, Tour } from '@/_models/Tour';
import ClassicPublicAsset from './asset/classic/ClassicPublicAsset';
import ModernPublicAsset from './asset/modern/ModernPublicAsset';
import SlickPublicAsset from './asset/slick/SlickPublicAsset';
import * as all from './util/all';
import dynamic from 'next/dynamic';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const MessengerCustomerChat = dynamic(
  () => import('./tour/regular/messengerCustomerChat/MessengerCustomerChat'),
  {
    ssr: false,
  },
);

export default class PublicAsset extends Component<any, any> {
  setWhiteLabel: any;

  constructor(props: any) {
    super(props);
    this.state = {
      tour: null,
      whiteLabelData: null,
    };
    this.setWhiteLabel = all.setWhiteLabel.bind(this);
  }

  componentDidMount() {
    all
      .fetchData('public/getAsset', 'POST', {
        id: this.props.matterId,
      })
      .then(async (data) => {
        if (!data.tour) {
          toast.error("Couldn't find this tour in our databases");
        } else {
          // @ts-ignore
          window.tourId = data.tour.id;
          // @ts-ignore
          window.multiPath = [];
          const tour = new Tour(data.tour);
          if (tour.floorPlans.length > 0) tour.floorPlans[0].selected = true;
          this.setWhiteLabel(tour);
          this.setState({
            tour,
            selectedPlan: tour.floorPlans.length > 0 ? tour.floorPlans[0].url : null,
          });
        }
      })
      .catch((err) => {
        console.error(err.message);
      });
  }

  public render() {
    const { tour, whiteLabelData } = this.state;

    return tour ? (
      <div>
        {tour.assetPageType === AssetPageType.Classic && (
          <ClassicPublicAsset
            tour={tour}
            whitelabel={whiteLabelData}
            selectedPlan={this.state.selectedPlan}
            googleKey={this.props.googleKey}
            reactAws={this.props.reactAws}
            menuItemClickedBookingPage={this.props.menuItemClickedBookingPage}
          />
        )}
        {tour.assetPageType === AssetPageType.Slick && (
          <SlickPublicAsset
            tour={tour}
            whitelabel={whiteLabelData}
            selectedPlan={this.state.selectedPlan}
            googleKey={this.props.googleKey}
            reactAws={this.props.reactAws}
            menuItemClickedBookingPage={this.props.menuItemClickedBookingPage}
            matterId={this.props.matterId}
          />
        )}
        {tour.assetPageType === AssetPageType.Modern && (
          <ModernPublicAsset
            tour={tour}
            whitelabel={whiteLabelData}
            selectedPlan={this.state.selectedPlan}
            googleKey={this.props.googleKey}
            reactAws={this.props.reactAws}
            menuItemClickedBookingPage={this.props.menuItemClickedBookingPage}
            matterId={this.props.matterId}
          />
        )}

        {tour.messengerLink && tour.messengerGreeting && (
          <MessengerCustomerChat
            pageId={tour.messengerLink}
            loggedInGreeting={tour.messengerGreeting}
            loggedOutGreeting={tour.messengerGreeting}
            themeColor={whiteLabelData?.secondaryColor || '#ea475c'}
          />
        )}
      </div>
    ) : (
      <LoadingProgress />
    );
  }
}
